import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const root = css`
  max-inline-size: ${spacing(60.75)}; // 486px
  inline-size: calc(100% - ${spacing(2)});
  max-block-size: calc(100% - ${spacing(2)});
`
export const suggest = css`
  position: relative;

  ::before {
    /* Убираем лишние divider, которые были реализованы через ::before */
    content: none;
  }
`
export const grid = css`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`

export const errorMessage = css`
  margin-block-start: ${spacing(0.5)};
`

export const icon = css`
  position: absolute;
  top: 0;
  right: 0;
`

export const modalFooter = css`
  z-index: 1;
`

/**
 * @todo – Тикет на доработку https://st.yandex-team.ru/CARGODEV-60588
 */
/** Насильно переопределяем gwc'шную высоту, тк очень криво сделаны отступы в мультилайн режиме */
export const multiline = css`
  & > div {
    padding-block: ${spacing(1)};
    min-block-size: auto;
  }
`

export const header = css`
  padding-block-end: ${spacing(2)};
`
